import React, { useEffect } from 'react';
import { SubMenu, MenuItem } from 'react-pro-sidebar';

const SidebarSubMenu = ({ title, icon, items, selectedItem, onSelectItem }) => {
  return (
    <SubMenu
      label={title}
      icon={icon}
      style={{ pointerEvents: 'auto', backgroundColor: '#003244' }}
      className="my-4 text-xl"
    >
      {items.length > 0 ? (
        items.map((item) => (
          <MenuItem
            key={item.id}
            style={{
              pointerEvents: 'auto',
              backgroundColor: '#003244',
              color: '#e0f2ff',
            }}
            className="capitalize"
          >
            <label className="flex cursor-pointer items-center space-x-4">
              <input
                type="radio"
                name={title}
                value={item.id}
                checked={selectedItem?.id === item.id}
                onChange={() => onSelectItem(item)}
                className="size-4 text-blue-500"
              />
              <span className="text-lg capitalize">
                {item.product_name
                  .split('-')
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(' ')}
              </span>
            </label>
          </MenuItem>
        ))
      ) : (
        <MenuItem
          style={{ pointerEvents: 'none', backgroundColor: 'transparent' }}
        >
          No items available
        </MenuItem>
      )}
    </SubMenu>
  );
};

export default SidebarSubMenu;
